export abstract class MpsBaseRepository<T> {
  public mockData: T[] = [];
  protected primaryKey: keyof T = 'id' as keyof T;
  protected timestampFields: { createdAt?: keyof T; updatedAt?: keyof T } = {
    createdAt: 'createdAt' as keyof T,
    updatedAt: 'updatedAt' as keyof T,
  };

  constructor(primaryKey?: keyof T, timestampFields?: { createdAt?: keyof T; updatedAt?: keyof T }) {
    if (primaryKey) {
      this.primaryKey = primaryKey;
    }
    if (timestampFields) {
      this.timestampFields = timestampFields;
    }
  }

  abstract findById(id: any): T | undefined;

  abstract findByKey(key: keyof T, value: any): T | undefined;

  abstract findAll(): T[];

  abstract create(item: Partial<T>): T;

  abstract update(id: any, item: Partial<T>): T | undefined;

  abstract delete(id: any): void;

  abstract nextPrimaryKey(): any;
}
